// Libraries
import React from 'react'

// Components
import Typography from '../typography'
import VideoPlayer from '../videoPlayer'
import WrapperImage from '../wrapperImage'
import SpeakerTile from './speakerTile'

// helpers
import { ModuleNames } from '../../../constants/componentNames.constants'
import ImgUtil from '../../../utils/img.utils'
import { findTarget, matchLocaleToMicrocopy } from '../../../utils/microcopy.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import speakerTextMicrocopy from './speakerBiosStaticQuery'

// Styles
import { SpeakerTextContainer } from './style'

const SpeakerText = (props: any) => {
  if (!props?.data) return null

  let speakerBiosMicrocopy = props.data?.speakerBiosMicrocopy
    ? props.data?.speakerBiosMicrocopy
    : speakerTextMicrocopy.allContentfulSpeakerBiosMicrocopy()

  let localeSpeakerBios = speakerBiosMicrocopy?.allContentfulMicrocopySet?.edges
    ? matchLocaleToMicrocopy(
        speakerBiosMicrocopy?.allContentfulMicrocopySet?.edges,
        'SpeakerBios',
        ''
      )
    : null

  const useCase = props.data.useCase
  const accentNumber = props.data.accentNumber
  const mainImageAlt = props.data.mainImage?.altText
  const mainImageSrc = props.data.mainImage?.image?.file?.url
  const accentImageAlt = props.data.accentImage?.altText
  const accentImageSrc = props.data.accentImage?.image?.file?.url
  const eyebrow = props.data.eyebrow
  const theme = props.data.theme
  const title = props.data.title
  const speakers = props.data.speakers
  const description = props.data.description
  const mainImageType = props.data.mainImage?.__typename
  const backgroundImg = props.data?.background?.image?.file?.url
    ? ImgUtil.getResizedImageUrl(props.data.background.image.file.url, ``)
    : ''

  let speakerLabel = props.data.speakerLabel
  let seeBioText = ''

  if (localeSpeakerBios?.values) {
    if (!speakerLabel) {
      speakerLabel = findTarget('ListLabel.text', localeSpeakerBios.values, false) || speakerLabel
    }
    seeBioText = findTarget('BioLink.text', localeSpeakerBios.values, false)
  }

  let videoType, videoId, start
  if (mainImageType === ModuleNames.WRAPPER_VIDEO) {
    if (props.data?.mainImage?.youtubeId) {
      videoType = 'youtube'
      videoId = props.data?.mainImage?.youtubeId
    } else if (props.data?.mainImage?.vimeoId) {
      videoType = 'vimeo'
      videoId = props.data?.mainImage?.vimeoId
    }
    start = props.data?.mainImage?.start
  }

  return (
    <SpeakerTextContainer
      background={backgroundImg}
      $theme={theme}
      $mainImage={!!mainImageSrc}
      useCase={useCase}
      data-cy="SpeakerText">
      <div className="SpeakerText__Dots"></div>
      <div className="SpeakerText__Top">
        <div className="SpeakerText__AccentContainer">
          {useCase === 'Number Accent' && accentNumber && (
            <p className="SpeakerText__Accent">{accentNumber}</p>
          )}
          {useCase === 'Image Accent' && accentImageSrc && (
            <WrapperImage
              className="SpeakerText__AccentImage"
              src={ImgUtil.getResizedImageUrl(accentImageSrc, `width=360`)}
              alt={accentImageAlt}
              threshold={650}
            />
          )}
        </div>
        <div className="SpeakerText__Intro">
          {mainImageSrc && mainImageType == ModuleNames.WRAPPER_VIDEO && (
            <VideoPlayer
              width={'100%'}
              height="429"
              className="SpeakerText__MainImage"
              videoId={videoId}
              img={mainImageSrc}
              type={videoType}
              backgroundAltText={mainImageAlt}
              backgroundImgParams={'width=690'}
              start={start}
            />
          )}
          {mainImageSrc && mainImageType == ModuleNames.WRAPPER_ASSET && (
            <WrapperImage
              className="SpeakerText__MainImage"
              src={ImgUtil.getResizedImageUrl(mainImageSrc, ``)}
              alt={mainImageAlt}
              threshold={650}
            />
          )}
          {eyebrow && (
            <Typography className="SpeakerText__Eyebrow" type="labelAlt">
              {eyebrow}
            </Typography>
          )}
          {title && (
            <Typography className="SpeakerText__Title" type="header2">
              {title}
            </Typography>
          )}
          {description && (
            <Typography className="SpeakerText__Description" type="body">
              {renderRichText(description)}
            </Typography>
          )}
        </div>
      </div>
      {speakers?.length && (
        <div className="SpeakerText__Bottom">
          {speakerLabel && (
            <Typography className="SpeakerText__SpeakerLabel" type="labelAlt">
              {speakerLabel}
            </Typography>
          )}
          <div className="SpeakerText__Bios-Container">
            {speakers.map((speaker: any) => {
              return (
                <SpeakerTile {...speaker} microcopy={localeSpeakerBios} seeBioText={seeBioText} />
              )
            })}
          </div>
        </div>
      )}
    </SpeakerTextContainer>
  )
}

export default SpeakerText
